import { Gender } from '@/dataV3/Common/Gender'
import { FlatHydraCollection } from 'emt-library'
import { UserCard } from '@/dataV3/Search/UserCard'
import { ObjectKeys } from '@/utils'

export enum SearchType {
  recommendation = 'recommendation',
  distance = 'distance',
  createdAt = 'createdAt',
}

export type SearchFiltersValues = {
  name?: string
  gender?: Gender
  size?: string[]
  breed?: string[]
  species?: string[]
  distance?: number
  distanceMin?: number
  entrustFewHours?: boolean
  entrustDayNight?: boolean
  entrustWeekendHoliday?: boolean
  availabilityWeekend?: boolean
  availabilityWeekNight?: boolean
  availabilityWeekDay?: boolean
  niceWithChildren?: boolean
  niceWithDogs?: boolean
  niceWithCats?: boolean
}

export type SearchFiltersKeys = keyof SearchFiltersValues

export const generateDefaultFiltersValues = (defaultDistance = 10): SearchFiltersValues => ({
  name: '',
  gender: undefined, // Need to keep undefined, to manage reset filters
  size: [],
  breed: [],
  species: [],
  distance: defaultDistance,
  entrustFewHours: false,
  entrustDayNight: false,
  entrustWeekendHoliday: false,
  availabilityWeekend: false,
  availabilityWeekNight: false,
  availabilityWeekDay: false,
  niceWithChildren: false,
  niceWithDogs: false,
  niceWithCats: false,
})

export const filtersValuesKeys: SearchFiltersKeys[] = ObjectKeys(generateDefaultFiltersValues())

export type SearchResults = FlatHydraCollection<UserCard>
